import { readPath } from "./RequestBuilder.ts";
import { transformValue } from "./HtmlExtractor.ts";
import {
  ExtractionError,
  type ExtractionRule,
  type FieldRule,
  type RecordValue,
  type SourceProfile,
  type Value,
} from "./types.ts";
export function parseJson(text: string): Value {
  try {
    return JSON.parse(text) as Value;
  } catch {
    throw new ExtractionError("INVALID_JSON", "La respuesta no contiene JSON válido.");
  }
}
export function jsonField(
  root: unknown,
  rule: FieldRule,
  finalUrl: string,
  profile: SourceProfile,
): Value {
  const value = readPath(root, rule.path ?? "");
  if (value === undefined || value === null) {
    if (rule.required === false) return null;
    throw new ExtractionError("SELECTOR_MISMATCH", `Ruta JSON ausente: ${rule.path ?? "(raíz)"}`);
  }
  return rule.all && Array.isArray(value)
    ? value.map((item) => transformValue(item as Value, { ...rule, all: false }, finalUrl, profile))
    : transformValue(value as Value, rule, finalUrl, profile);
}
export function extractJson(
  root: Value,
  rule: ExtractionRule,
  finalUrl: string,
  profile: SourceProfile,
): RecordValue[] {
  const selected = readPath(root, rule.path ?? "");
  if (selected === undefined || selected === null)
    throw new ExtractionError("SELECTOR_MISMATCH", `Ruta JSON ausente: ${rule.path}`);
  const rows = Array.isArray(selected) ? selected : [selected];
  if (!rows.length && !rule.allowEmpty)
    throw new ExtractionError("SELECTOR_MISMATCH", "Lista JSON vacía sin allowEmpty.");
  return rows.map((row) =>
    Object.fromEntries(
      Object.entries(rule.fields).map(([key, field]) => [
        key,
        jsonField(row, field, finalUrl, profile),
      ]),
    ),
  );
}
